import React from 'react'
import { Link, Outlet} from "react-router-dom"
import { Layout } from '../components/layout/Layout'
import App from '../App'

export const Store = () => {
  return (
    <>
    <App />
    </>
  )
}
